import { combineReducers } from "redux";

import FiltersReducer from "./filters/reducer";
import DashboardFinanzasReducer from "./dashboardFinanzas/reducer";
import DashboardProyectosReducer from "./dashboardProyectos/reducer";
import DashboardMarketingReducer from "./dashboardMarketing/reducer";
import DashboardFinanzasV2Reducer from "./dashboardFinanzasV2/reducer";

const rootReducer = combineReducers({
  Filters: FiltersReducer,
  DashboardFinanzas: DashboardFinanzasReducer,
  DashboardFinanzasV2: DashboardFinanzasV2Reducer,
  DashboardProyectos: DashboardProyectosReducer,
  DashboardMarketing: DashboardMarketingReducer,
});

export default rootReducer;
